import React from 'react'
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import BaseComponent from "../pages/base/BaseComponent";
import ModelDetailInformationModal from "./ModelDetailInformationModal";
import {Link} from "react-router-dom";

export default class ModelInformationCard extends BaseComponent{

    constructor() {
        super();
        let state = this.state
        state.modelDetailInformationModal = false
        this.setState(state)
    }

    render() {
        let {modelDetailInformationModal} = this.state
        let {model} = this.props
        if(isEmpty(model)){
            model = {}
        }
        let {headerClassName} = this.props
        return (
            <>
                <ModelDetailInformationModal
                    model={model}
                    show={modelDetailInformationModal}
                    onClose={() => {
                        this.setState({modelDetailInformationModal:false})
                    }}/>
                <Card border="light" className="bg-white shadow-sm mb-4">
                    <Card.Header className={headerClassName}>
                        {label.Model}
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                        <span>{label.Name}</span>
                        <Card.Text className="fw-bolder">
                            <Link
                                className="bg-transparent text-black p-0 fw-bolder text-underline rounded-0 border-0"
                                to={"#"} onClick={(e) => {
                                e.preventDefault()
                                this.setState({modelDetailInformationModal:true})
                            }}>
                                {model.name}
                            </Link>
                        </Card.Text>
                        <span>{label.SystemType}</span>
                        <Card.Text className="fw-bolder">{model.systemType}</Card.Text>
                        <span>{label.PartNumber}</span>
                        <Card.Text className="fw-bolder">{model.partNumber}</Card.Text>
                    </Card.Body>
                </Card>
            </>
        );
    }

}

ModelInformationCard.propTypes = {
    model : PropTypes.any,
    headerClassName: PropTypes.string
}